<template>
<section class="footer">
    <div class="footer-div-wrap-copy">
        <div class="footer-div-1">
            <div class="footer-div1-left">
                <div class="div-block-2097"><img loading="lazy" src="@/assets/images/OhMyMeds_Logo-Update.svg" alt="" class="image-549-copy">
                    <div class="footer-addres">255 S Orange Avenue<br>Suite 104 #2347<br>Orlando, FL 32801<br>United States<br></div>
                </div>
                <div class="div-block-1784">
                    <div class="code-embed w-embed w-script">
                        <a href="https://www.legitscript.com/websites/?checker_keywords=ohmymeds.com" target="_blank"><img loading="lazy" src="https://static.legitscript.com/seals/321841.png" alt="" width="75" height="80" class="image-529"></a>
                    </div>
                </div>
            </div>
            <div class="footer-div1-right">
                <div class="footer-column-div-copy legal">
                    <div class="footer-header-copy">Legal</div>
                    <div class="footer-text-link" v-for="(item, index) in legalLinks" :key="`legal-${index}`">
                        <a :href="item.link" class="link-copy" target="_blank">{{ item.name }}</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="div-block-1989"></div>
        <div class="footer-div-2">
        <div class="text-block-143-copy">© 2025 Oh My! Meds LLC. All rights reserved.</div>
        <div class="footer-div2-right"><img loading="lazy" src="@/assets/images/icon_card_visa_1icon_card_visa.png" alt="" class="image-2"><img loading="lazy" src="@/assets/images/icon_card_mastercard_1icon_card_mastercard.png" alt="" class="image-2"><img loading="lazy" src="@/assets/images/icon_card_amex_1icon_card_amex.png" alt="" class="image-2"></div>
    </div>
    </div>
    

</section>
</template>

<script>
export default {
    name: 'footerComponent',
    data() {
        return {
            appMainWeb: process.env.VUE_APP_HOMEPAGE,
            assetPath: '/images', // Path to your assets/images
            appName: "OhMyMeds",
            legalLinks: [{
                    name: 'HIPAA Notice',
                    link: `${process.env.VUE_APP_HOMEPAGE}/hipaa`
                },
                {
                    name: 'Privacy Policy',
                    link: `${process.env.VUE_APP_HOMEPAGE}/privacy`
                },
                {
                    name: 'Returns & Refund Policy',
                    link: `${process.env.VUE_APP_HOMEPAGE}/returns`
                },
                {
                    name: 'Terms Of Use',
                    link: `${process.env.VUE_APP_HOMEPAGE}/terms`
                },
                {
                    name: 'CCPA Opt-Out',
                    link: `${process.env.VUE_APP_HOMEPAGE}/ccpa`
                },
                {
                    name: 'TeleHealth Consent',
                    link: `${process.env.VUE_APP_HOMEPAGE}/telehealth`
                }
            ]
        }
    },
    computed: {
        getYear() {
            return new Date().getFullYear();
        },
    },

}
</script>
